import React, { FC, memo, useMemo } from 'react'
import NewsTickerEntry from '@sport1/news-styleguide/NewsTickerEntry'
import { NewsTickerEntryProps } from '@sport1/news-styleguide/Types'
import Link, { LinkProps } from 'next/link'
import useCurrentDeviceSize from '../../hooks/useCurrentDeviceSize'

type WrappedNewsTickerEntryProps = NewsTickerEntryProps & LinkProps

const WrappedNewsTickerEntry: FC<WrappedNewsTickerEntryProps> = ({ href, ...rest }) => {
    const { deviceSizeDesktop, deviceSizeTablet } = useCurrentDeviceSize()

    const newsTickerEntrySize = useMemo(() => {
        if (deviceSizeDesktop) {
            return 'L'
        } else if (deviceSizeTablet) {
            return 'M'
        }
        return 'S'
    }, [deviceSizeDesktop, deviceSizeTablet])

    return (
        <Link href={href} passHref legacyBehavior>
            <NewsTickerEntry
                {...rest}
                href={href}
                hasBorder={deviceSizeDesktop}
                size={newsTickerEntrySize}
            />
        </Link>
    )
}

export default memo(WrappedNewsTickerEntry)
